export const type= 'NOSOTROS-INFO'
const   nosotrosInfo = (id)=>({
    type,
    id
})
export default nosotrosInfo